import { CarouselDatum } from '@/features/services/components/Carousel'

export const useCarouselData = (): CarouselDatum[] => {
  return [
    {
      image:
        'https://pdpa-core-assets.s3.ap-southeast-1.amazonaws.com/images/PDPA-Training-PromoteVideo.mp4',
      poster: '/images/services/training/poster1.png',
    },
  ]
}
